module.exports = __webpack_public_path__ + "static/media/How can I customized Visa types or status.7232e62c.png";